(function () {
  var selector = [
    '.home-approved-v4__benefit-video',
    '.product-intro-premium__viewport-video'
  ].join(',');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;
  var observer;

  function pauseVideo(video) {
    video.pause();
    video.removeAttribute('autoplay');
  }

  function playVideo(video) {
    if (reducedMotion.matches || saveData || document.hidden) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function registerVideos(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var videos = root.querySelectorAll(selector);

    videos.forEach(function (video) {
      if (video.dataset.viewportVideoReady === 'true') return;
      video.dataset.viewportVideoReady = 'true';
      video.muted = true;
      video.playsInline = true;
      pauseVideo(video);

      if (reducedMotion.matches || saveData) {
        video.preload = 'none';
        return;
      }

      if (observer) observer.observe(video);
    });
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.18) {
            playVideo(entry.target);
          } else {
            pauseVideo(entry.target);
          }
        });
      }, {
        rootMargin: '120px 0px',
        threshold: [0, 0.18, 0.6]
      });
    }

    registerVideos(document);
  }

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll(selector).forEach(function (video) {
      if (document.hidden) {
        pauseVideo(video);
      } else {
        var rect = video.getBoundingClientRect();
        var isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        if (isVisible) playVideo(video);
      }
    });
  });

  function handleMotionPreference(event) {
    document.querySelectorAll(selector).forEach(function (video) {
      if (event.matches) {
        pauseVideo(video);
        video.preload = 'none';
      } else {
        video.preload = 'metadata';
      }
    });
  }

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', handleMotionPreference);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(handleMotionPreference);
  }

  document.addEventListener('shopify:section:load', function (event) {
    registerVideos(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
